// extracted by mini-css-extract-plugin
module.exports = {"segment":"styles_segment__smHpv","title":"styles_title__3xlCB","content":"styles_content__1nP2L","spin":"styles_spin__e0p2w"};